import { Table, TableBody, TableHead, TableRow, Tooltip } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  ActionIconButton,
  PaginationTable,
  NoDataSkeleton,
} from '../../../common/components';
import { formatDate } from '../../../utils/formatUtils';

const MovementConceptsDataTable = ({
  movementConcepts,
  totalMovementConcepts,
  page,
  totalPages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDelete,
  isLoading,
  LoadingComponent,
}) => {
  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <>
      <GeneralTableBox>
        <Table stickyHeader>
          <TableHead>
            <TableRow
              sx={{
                '& th': {
                  py: { xs: 1, md: 1.5 },
                },
              }}
            >
              <HeadTableCell>Nombre</HeadTableCell>
              <HeadTableCell>Código</HeadTableCell>
              <HeadTableCell>Descripción</HeadTableCell>
              <HeadTableCell>Fecha Creación</HeadTableCell>
              <HeadTableCell>Fecha Actualización</HeadTableCell>
              <HeadTableCell>Acciones</HeadTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {movementConcepts && movementConcepts.length > 0 ? (
              movementConcepts.map((concept) => (
                <TableRow
                  key={concept.uuid}
                  sx={{
                    '& td': {
                      py: { xs: 0.75, md: 1 },
                    },
                  }}
                >
                  <RowTableCell>{concept.name}</RowTableCell>
                  <RowTableCell>{concept.code || '-'}</RowTableCell>
                  <RowTableCell>
                    {concept.description ? (
                      <Tooltip title={concept.description} arrow>
                        <span>{concept.description}</span>
                      </Tooltip>
                    ) : (
                      '-'
                    )}
                  </RowTableCell>
                  <RowTableCell>{formatDate(concept.created_at)}</RowTableCell>
                  <RowTableCell>{formatDate(concept.updated_at)}</RowTableCell>
                  <RowTableCell>
                    <ActionIconButton variant="edit" onClick={() => onEdit(concept)} />
                    <ActionIconButton
                      variant="delete"
                      onClick={() => onDelete(concept)}
                      disabled={!concept.is_active}
                    />
                  </RowTableCell>
                </TableRow>
              ))
            ) : (
              <NoDataSkeleton message="No se encontraron conceptos de movimiento" />
            )}
          </TableBody>
        </Table>
      </GeneralTableBox>

      {totalMovementConcepts > rowsPerPage && (
        <PaginationTable
          page={page}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          totalCount={totalMovementConcepts}
        />
      )}
    </>
  );
};

export default MovementConceptsDataTable;
